import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tog-progress-bar',
  templateUrl: 'progress-bar.template.html',
  styleUrls: ['progress-bar.scss']
})
export class ProgressBarComponent implements OnInit {
  _steps: string[];
  segmentWidth: string = '';
  @Input() completedSteps: number = 0;

  ngOnInit() {
    this.calculateSegmentWidth();
  }

  calculateSegmentWidth() {
    this.segmentWidth = (100 / this._steps.length) + '%';
  }

  @Input() set steps(steps: string[]) {
    this._steps = steps;
    this.calculateSegmentWidth();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/progress-bar/progress-bar.component.ts